import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '@sm/intl';
import { Banner } from '@wds/banner';
import { Button } from '@wds/button';
import { Typography } from '@wds/typography';
import { Box } from '@wds/box';
const COPY = {
  ErrorAlertHeader: {
    id: 'buildWithAI.PromptInputUnavailable.ErrorAlertHeader',
    defaultMessage: 'No more prompts available',
    description: '[Type: label][Vis: high] - Header for alert showing that prompt input is unavailable because prompt limit has been reached'
  },
  ErrorAlertBody: {
    id: 'buildWithAI.PromptInputUnavailable.ErrorAlertBody',
    defaultMessage: "You've reached your daily prompt limit. Continue to the next step to finish editing, or try again tomorrow. You can also start from scratch (a blank survey).",
    description: '[Type: label][Vis: high] - Body text for alert showing that prompt input is unavailable because prompt limit has been reached'
  },
  LinkContinue: {
    id: 'buildWithAI.PromptInputUnavailable.LinkContinue',
    defaultMessage: 'Continue with survey',
    description: '[Type: label][Vis: med] - Link text for proceeding to next step'
  },
  LinkRestart: {
    id: 'buildWithAI.PromptInputUnavailable.LinkRestart',
    defaultMessage: 'Start from scratch',
    description: '[Type: label][Vis: med] - Link text for restarting the process'
  }
};
/**
 * Error alert showing that no more prompts are available.
 */
const PromptInputUnavailable = ({
  onFinished,
  onCancel
}) => _jsxs(Banner, {
  color: "error",
  showIcon: true,
  "aria-label": t(COPY.ErrorAlertHeader),
  actions: _jsxs(_Fragment, {
    children: [_jsx(Button, {
      color: "alt",
      onClick: () => {
        onFinished === null || onFinished === void 0 ? void 0 : onFinished();
      },
      children: t(COPY.LinkContinue)
    }), _jsx(Box, {
      ml: 3,
      element: "span",
      children: _jsx(Button, {
        variant: "text",
        color: "link",
        onClick: () => {
          onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        },
        children: t(COPY.LinkRestart)
      })
    })]
  }),
  children: [_jsx(Typography, {
    component: "p",
    variant: "cardTitle",
    weight: "medium",
    children: t(COPY.ErrorAlertHeader)
  }), _jsx(Box, {
    mt: 3,
    children: _jsx(Typography, {
      component: "p",
      children: t(COPY.ErrorAlertBody)
    })
  })]
});
export default PromptInputUnavailable;